import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {SensorAlertApi} from '@/sdk/api-services';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class WarningsListComponent extends VueWrapper {
    @Prop({
        required: true,
    })
    public locationId!: string;

    public sensorAlertApis: SensorAlertApi = new SensorAlertApi();

    public alertsList: any[] = [];

    private alertsInterval: any;

    public mounted(): void {
        this.getAlerts();
        this.alertsInterval = setInterval(() => {
            this.getAlerts();
        }, 60000); // 1 minute interval
    }

    public beforeDestroy(): void {
        clearInterval(this.alertsInterval);
    }

    public getAlerts() {
        this.sensorAlertApis
            .getAlertsByLocationId(this.locationId)
            .then(res => {
                console.log(res);
                this.alertsList = res;
            })
            .catch(err => {
                console.log(err);
            });
    }

    public resolveAlert(alert: any) {
        console.log(alert);
    }

    public getAlertType(type: string) {
        switch (type) {
            case 'warning':
                return 'warning';
            case 'alarm':
                return 'error';
            default:
                return '';
        }
    }

    public getAlertColor(type: string) {
        switch (type) {
            case 'warning':
                return '';
            case 'alarm':
                return 'deep-orange';
            default:
                return '';
        }
    }
}
